// LICENSE_CODE ZON
'use strict';

/*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';
var Zlxc_label = ({
  label
}) => {
  if (!label) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "env-label visible"
  }, /*#__PURE__*/React.createElement("div", {
    className: `label label-${label == 'zlxc' ? 'primary' : 'danger'}`
  }, label));
};
export { Zlxc_label };